"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _defs, _use, _g;
var Airplay = function Airplay(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 23 26"
  }, props), _defs || (_defs = /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "0",
    width: "32",
    height: "32"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-175.000000, -164.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(16.000000, 136.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(16.000000, 24.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(139.000000, 0.000000)"
  }, _use || (_use = /*#__PURE__*/_react.default.createElement("use", {
    id: "Padding",
    "fill-opacity": "0",
    fill: "#FFFFFF"
    // xlink:href="#path-1"
  })), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    id: "home",
    mask: "url(#mask-2)",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Shape"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,8.4 L10.5,0 L21,8.4 L21,21.6 C21,22.9254834 19.9553311,24 18.6666667,24 L2.33333333,24 C1.04466892,24 0,22.9254834 0,21.6 L0,8.4 Z"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "7 24 7 12 14 12 14 24"
  }))))))))));
};
var _default = exports.default = Airplay;